import {computed, toValue, type MaybeRefOrGetter} from 'vue';
import type {PrismicDocument} from '@prismicio/types';
import type {PinnedContentHeroSlice} from '@prismicio-types';
import {hasPinnedContent, pinnedHeroContent, pinnedSideContents, withDisplayDate} from '../resolvePinnedHeroContent';
import {fallbackHeroContent, fallbackSideContents} from '../resolvePinnedHeroFallback';
import type {FilledContent} from '~~/app/composables/contentHelpers';

export function usePinnedContentHero(
    sliceInput: MaybeRefOrGetter<PinnedContentHeroSlice>,
    fallbackDocumentsInput?: MaybeRefOrGetter<PrismicDocument[] | null | undefined>,
) {
    const hasPinned = computed(() => hasPinnedContent(toValue(sliceInput)));

    const hero = computed((): FilledContent | null => {
        if (hasPinned.value) return pinnedHeroContent(toValue(sliceInput)) ?? null;
        return fallbackHeroContent(toValue(fallbackDocumentsInput));
    });

    const sides = computed(() => {
        const items = hasPinned.value ? pinnedSideContents(toValue(sliceInput)) : fallbackSideContents(toValue(fallbackDocumentsInput));
        return withDisplayDate(items);
    });

    return {hero, sides, hasPinned};
}
